import { buildDownloadFilename } from './fileNameHelper';


async function downloadFileWithUtf8Name(url: string, filename: string, suffix?: string) {
  try {
    // 使用 fetch API 获取文件
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`下载失败：HTTP ${response.status}`);
    }

    // 使用智能文件名构造函数
    const finalFilename = buildDownloadFilename(filename, response, suffix);

    // 将响应转换为 Blob
    const blob = await response.blob();


    // 创建对象 URL
    const blobUrl = URL.createObjectURL(blob);

    // 创建下载链接
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = finalFilename;
    link.style.display = 'none';
    document.body.appendChild(link);

    // 触发下载
    link.click();

    // 清理资源
    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    }, 100);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error('❌ 文件下载错误：', error);
    alert(`下载失败：${error.message}`);
  }
}


export default downloadFileWithUtf8Name;